import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { EvaluacionContextoModel } from 'src/app/model/AutoEvaluacionContexto';
import { ResponseEvaluacionContextoModel } from 'src/app/model/AutoevaluacionContexto.model';
import { apiService } from 'src/app/service/api.service';
import Swal from 'sweetalert2';
import { AutoevaluacionInicioViewComponent } from '../../autoevaluacion-inicio-view.component';

@Component({
  selector: 'app-contexto',
  templateUrl: './contexto.component.html',
  styleUrls: ['./contexto.component.css']
})
export class ContextoComponent implements OnInit {

  @ViewChild('divSpinner') divSpinner:ElementRef;
  cargando :boolean;
  evaluacionContextoModel = new EvaluacionContextoModel();

  textButtonFinalizar:string='Finalizar'
  buttonFinalizar: boolean = false;

  contextoFormGroup = new FormGroup({
    respuesta1: new FormControl('', [Validators.required]),
    respuesta2: new FormControl('', [Validators.required]),
    respuesta3: new FormControl('', [Validators.required]),
    respuesta4: new FormControl('', [Validators.required]),
    respuesta5: new FormControl('', [Validators.required]),
    respuesta6: new FormControl('', [Validators.required]),
    respuesta8: new FormControl('', [Validators.required]),
    respuesta9: new FormControl('', [Validators.required]),
    respuesta10: new FormControl('', [Validators.required]),
    respuesta71: new FormControl(''),
    respuesta72: new FormControl(''),
    respuesta73: new FormControl(''),
    respuesta74: new FormControl(''),
    respuesta75: new FormControl(''),
    respuesta7Otro: new FormControl(''),
  });


  constructor(
    private api: apiService,
    @Inject(AutoevaluacionInicioViewComponent) private parent: AutoevaluacionInicioViewComponent
  ) { }

  ngOnInit(): void {
    this.cargando = true
    this.cargaInicial();
    
  }

  cargaInicial(){   
    this.api.API_POST_getEvaluacionContexto(this.api.dataJardin.idJardinPeriodo).subscribe((response: ResponseEvaluacionContextoModel) => {
      this.evaluacionContextoModel = response.payload;
      if(this.evaluacionContextoModel.estado === 'finalizado'){
        this.contextoFormGroup.disable();
        this.textButtonFinalizar = 'Finalizado';
        this.buttonFinalizar = true;
      }
      const ForValue = this.contextoFormGroup;
      ForValue.get('respuesta1').setValue(this.evaluacionContextoModel.respuesta1);
      ForValue.get('respuesta2').setValue(this.evaluacionContextoModel.respuesta2);  
      ForValue.get('respuesta3').setValue(this.evaluacionContextoModel.respuesta3);
      ForValue.get('respuesta4').setValue(this.evaluacionContextoModel.respuesta4);
      ForValue.get('respuesta5').setValue(this.evaluacionContextoModel.respuesta5);
      ForValue.get('respuesta6').setValue(this.evaluacionContextoModel.respuesta6);
      ForValue.get('respuesta8').setValue(this.evaluacionContextoModel.respuesta8);
      ForValue.get('respuesta9').setValue(this.evaluacionContextoModel.respuesta9);
      ForValue.get('respuesta10').setValue(this.evaluacionContextoModel.respuesta10);
      ForValue.get('respuesta71').setValue(this.evaluacionContextoModel.respuesta71);
      ForValue.get('respuesta72').setValue(this.evaluacionContextoModel.respuesta72);
      ForValue.get('respuesta73').setValue(this.evaluacionContextoModel.respuesta73);
      ForValue.get('respuesta74').setValue(this.evaluacionContextoModel.respuesta74);
      ForValue.get('respuesta75').setValue(this.evaluacionContextoModel.respuesta75);
      ForValue.get('respuesta7Otro').setValue(this.evaluacionContextoModel.respuesta7Otro);
      this.cargando = false;
      this.divSpinner.nativeElement.style.display='none';
    },
    (err) => {
      this.cargando = false;
      this.divSpinner.nativeElement.style.display='none';
      console.log(err)
    })
  }

  guardar() {

    if(this.contextoFormGroup.invalid) {
      Swal.fire({
        title: 'Revise el formulario',
        text: 'Todas las preguntas son obligatorias',
        confirmButtonText: 'Revisar formulario'
      })
      return;

    }
    const forValue = this.contextoFormGroup.value;
    if(forValue.respuesta71 === false && forValue.respuesta72 === false
      && forValue.respuesta73 === false && forValue.respuesta74 === false && forValue.respuesta75 === false){
        Swal.fire({
          title: 'Revise el formulario',
          text: 'Seleccione una respuesta en la pregunta 7',
          confirmButtonText: 'Revisar formulario'
        })
        return;
    }
    if(forValue.respuesta75 === true && forValue.respuesta7Otro === ""){
        Swal.fire({
          title: 'Revise el formulario',
          text: 'El campo otro no puede estar vacio',
          icon: 'question',
          confirmButtonText: 'Revisar formulario'
        })
        return;
    }
    
    this.evaluacionContextoModel.respuesta1 = forValue.respuesta1;
    this.evaluacionContextoModel.respuesta2 = forValue.respuesta2;
    this.evaluacionContextoModel.respuesta3 = forValue.respuesta3;
    this.evaluacionContextoModel.respuesta4 = forValue.respuesta4;
    this.evaluacionContextoModel.respuesta5 = forValue.respuesta5;
    this.evaluacionContextoModel.respuesta6 = forValue.respuesta6;
    this.evaluacionContextoModel.respuesta8 = forValue.respuesta8;
    this.evaluacionContextoModel.respuesta9 = forValue.respuesta9;
    this.evaluacionContextoModel.respuesta10 = forValue.respuesta10;
    this.evaluacionContextoModel.respuesta71 = forValue.respuesta71;
    this.evaluacionContextoModel.respuesta72 = forValue.respuesta72;
    this.evaluacionContextoModel.respuesta73 = forValue.respuesta73;
    this.evaluacionContextoModel.respuesta74 = forValue.respuesta74;
    this.evaluacionContextoModel.respuesta75 = forValue.respuesta75;
    this.evaluacionContextoModel.respuesta7Otro = forValue.respuesta7Otro;
    
    this.divSpinner.nativeElement.style.display='';
    this.api.API_POST_finalizarEvaluacionContexto(this.evaluacionContextoModel).subscribe((response: any) => {
      this.divSpinner.nativeElement.style.display='none';

      Swal.fire({
        title: 'Listo!',
        text: 'El formulario se guardado correctamente',
        icon: 'success',
        confirmButtonText: 'Cerrar'
      })

      this.parent.context = false      

    },
    (err) => {
      this.divSpinner.nativeElement.style.display='none';
      console.log(err)
    })
    
    
  }

}

